// Inertia 페이지 resolver 로직 (테스트 가능하도록 분리).
// 컨벤션: pages/<name>.tsx → pages/<name>/index.tsx 순으로 찾는다.
type PageModule = { default: unknown };
type PageGlob = Record<string, () => Promise<unknown>>;

function importerFor(pages: PageGlob, name: string) {
  return pages[`../pages/${name}.tsx`] ?? pages[`../pages/${name}/index.tsx`];
}

// 페이지 이름이 실제 컴포넌트 파일로 매핑되는지(모듈을 실행하지 않고) 확인.
export function pageExists(pages: PageGlob, name: string): boolean {
  return Boolean(importerFor(pages, name));
}

export function createPageResolver(pages: PageGlob) {
  return async (name: string) => {
    const importer = importerFor(pages, name);
    if (!importer) {
      throw new Error(`Page not found: ${name}`);
    }

    const mod = (await importer()) as PageModule;
    return mod.default as React.ComponentType;
  };
}
